import LocalBookMutations from "@/graphql/LocalBookMutations";
import IRIS, { createIri } from "@/iris";

const PHYSICAL_FORMATS = {
	paperback: {
		mimeType: "print",
		schemaOrgUrl: "https://schema.org/Paperback",
	},
	hardcover: {
		mimeType: "print",
		schemaOrgUrl: "https://schema.org/Hardcover",
	},
};

export default {
	data() {
		return {
			isPhysicalProduct: false,
			physicalProductTitle: "",
			bindingType: "paperback",
			creatingPhysicalProduct: false,
		};
	},

	computed: {
		physicalProductTitleRules() {
			return [
				(v) =>
					!!v ||
					this.$t("admin.productsDatabase.importWizard.upload.titleRequired"),
				(v) =>
					(v && v.length >= 3) ||
					this.$t("admin.productsDatabase.importWizard.upload.titleMinLength"),
			];
		},

		isPhysicalProductValid() {
			return (
				this.physicalProductTitle &&
				this.physicalProductTitle.trim().length >= 3
			);
		},
	},

	watch: {
		bindingType(newVal) {
			if (this.productInfoManager && this.isPhysicalProduct) {
				this.productInfoManager.setPendingField(
					"book.format",
					this.createBookFormat(newVal),
				);
			}
		},
	},

	methods: {
		createBookFormat(formatId) {
			const format = PHYSICAL_FORMATS[formatId];
			return {
				id: createIri(IRIS.bookFormat, formatId),
				_id: formatId,
				mimeType: format?.mimeType || "print",
				schemaOrgUrl: format?.schemaOrgUrl || null,
			};
		},

		async createPhysicalProduct() {
			if (!this.isPhysicalProductValid) return;

			this.creatingPhysicalProduct = true;

			try {
				const result = await this.$apollo.mutate({
					mutation: LocalBookMutations.createLocalBook,
					variables: {
						input: {
							title: this.physicalProductTitle.trim(),
							format: createIri(IRIS.bookFormat, this.bindingType),
						},
					},
				});

				if (
					result.data &&
					result.data.createLocalBook &&
					result.data.createLocalBook.localBook
				) {
					const createdBook = result.data.createLocalBook.localBook;

					// Structure the response to match what's expected by the rest of the workflow
					const physicalProductInfo = {
						book: createdBook,
					};

					this.uploadedProductInfo = physicalProductInfo;
					this.isUploaded = true;
					this.hasError = false;

					if (this.productInfoManager) {
						this.productInfoManager.setUploadedData(physicalProductInfo);
					}

					// Show success notification
					this.$store.dispatch("snackbar/showSnackbar", {
						text: this.$t(
							"admin.productsDatabase.importWizard.upload.physicalProductCreated",
						),
						color: "success",
					});
				}
			} catch (error) {
				console.error("Error creating physical product:", error);
				this.hasError = true;

				this.$store.dispatch("snackbar/showSnackbar", {
					text: this.$t(
						"admin.productsDatabase.importWizard.upload.physicalProductError",
					),
					color: "error",
				});
			} finally {
				this.creatingPhysicalProduct = false;
			}
		},

		resetPhysicalProduct() {
			this.isPhysicalProduct = false;
			this.physicalProductTitle = "";
			this.creatingPhysicalProduct = false;
		},
	},
};
